import { Box, Button, Grid, IconButton, Input, VStack } from "@chakra-ui/react";
import { Text } from "@chakra-ui/react";
import { Field } from "@chakra-ui/react/field";
import { MdAdd as AddIcon, MdClose as CloseIcon } from "react-icons/md";

interface Ingredient {
  name: string;
  unit: string;
  quantity: string;
}

interface Props {
  ingredients: Ingredient[];
  error?: string;
  onChange: (index: number, field: string, value: string) => void;
  onAdd: () => void;
  onRemove: (index: number) => void;
  sectionHeadingStyle: object;
  smallInputStyle: object;
  dashedAddStyle: object;
  fieldRef: React.RefObject<HTMLDivElement | null>;
}

export default function IngredientList({
  ingredients, error, onChange, onAdd, onRemove,
  sectionHeadingStyle, smallInputStyle, dashedAddStyle, fieldRef,
}: Props) {
  const cols = "68px 140px 1fr 28px";

  return (
    <Box ref={fieldRef} w="100%">
      <Field.Root invalid={!!error} w="100%">
        <Box {...sectionHeadingStyle}>Ingredients</Box>
        <VStack gap={2} align="stretch" w="100%">
          <Grid templateColumns={cols} gap="5px" px="2px" w="100%">
            <Text fontSize="9px" fontWeight="600" letterSpacing="0.06em" textTransform="uppercase" color="text.muted" textAlign="center">Qty</Text>
            <Text fontSize="9px" fontWeight="600" letterSpacing="0.06em" textTransform="uppercase" color="text.muted">Unit</Text>
            <Text fontSize="9px" fontWeight="600" letterSpacing="0.06em" textTransform="uppercase" color="text.muted">Ingredient</Text>
            <Box />
          </Grid>

          {ingredients.map((ingredient, index) => (
            <Grid key={index} templateColumns={cols} gap="5px" alignItems="center" w="100%">
              <Input id={`ingredient-quantity-${index}`} value={ingredient.quantity} onChange={e => onChange(index, "quantity", e.target.value)} placeholder="—" textAlign="center" {...smallInputStyle} />
              <Input id={`ingredient-unit-${index}`} value={ingredient.unit} onChange={e => onChange(index, "unit", e.target.value)} placeholder="unit" {...smallInputStyle} />
              <Input id={`ingredient-name-${index}`} value={ingredient.name} onChange={e => onChange(index, "name", e.target.value)} placeholder="ingredient" {...smallInputStyle} />
              <IconButton
                aria-label="Remove ingredient"
                size="xs"
                variant="ghost"
                color="text.muted"
                borderRadius="8px"
                _hover={{ bg: "bg.muted", color: "status.error" }}
                disabled={ingredients.length === 1}
                onClick={() => onRemove(index)}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          ))}

          <Button {...dashedAddStyle} onClick={onAdd}>
            <AddIcon />
            Add ingredient
          </Button>
        </VStack>
        {error && <Field.ErrorText mt={2}>{error}</Field.ErrorText>}
      </Field.Root>
    </Box>
  );
}
